<template>
  <b-tooltip
    position="is-top"
    multilined
    append-to-body
    type="is-info"
    class="is-light"
  >
    <span class="leaderboard-score">{{ scoreBreakdown.total }}</span>
    <template v-slot:content>
      <table class="has-text-right">
        <tr
          v-for="(item, index) in scoreBreakdown.scoreItems"
          :key="item.label + item.unit"
          :class="{ 'has-text-grey': item.count === 0 }"
        >
          <td class="has-text-left is-italic pr-2">
            {{
              index && item.label === scoreBreakdown.scoreItems[index - 1].label
                ? ""
                : item.label
            }}
          </td>
          <td class="has-text-left">{{ item.count }} {{ item.unit }}</td>
          <td>&nbsp;×&nbsp;</td>
          <td>{{ item.multiplier }}</td>
          <td>&nbsp;=&nbsp;</td>
          <td>{{ item.points }}</td>
        </tr>
        <tr style="border-top: 1px solid #bbb">
          <td colspan="4">Total</td>
          <td>&nbsp;=&nbsp;</td>
          <td>{{ scoreBreakdown.total }}</td>
        </tr>
      </table>
    </template>
  </b-tooltip>
</template>

<script>
import { ClassRollLeaderboardCalculator } from "vue-chess-shared/calculators/ClassRollLeaderboardCalculator";

export default {
  name: "LectureLeaderboardScore",

  props: {
    student: {
      type: Object,
      required: true,
    },
  },

  computed: {
    scoreBreakdown() {
      return ClassRollLeaderboardCalculator.calculateLectureScoreBreakdown(
        this.student
      );
    },
  },
};
</script>

<style scoped>
.leaderboard-score {
  cursor: help;
  font-weight: bold;
  color: #007bff;
  background-color: #e3f2fd;
  padding: 0;
  border-radius: 2px;
  display: inline-block;
  min-width: 2rem;
  line-height: 2rem;
  text-align: center;
}
</style>
